import {
  AlertTriangleIcon,
  BookMarkedIcon,
  GoalIcon,
  HandIcon,
  LibraryBigIcon,
  MegaphoneIcon,
  PhoneIcon,
  ShieldIcon,
  ZapIcon,
} from 'lucide-react';

import { ChannelErrorTooltip } from '@/modules/campaigns/components/ChannelErrorTooltip';
import { IntegrationType } from '@/shared/types/integration';
import { SynthesisResponseCode, TryItCollection } from '@/shared/types/tryIt';

interface ResponseIconProps {
  error_code?: string;
  channel: IntegrationType;
  isInstructionsReply: boolean;
  isCollectionReply: boolean;
  isCampaignReply: boolean;
  isBroadcastReply: boolean;
  collection?: TryItCollection;
}

export const ResponseIcon = ({
  error_code,
  channel,
  isInstructionsReply,
  isCollectionReply,
  isCampaignReply,
  isBroadcastReply,
  collection,
}: ResponseIconProps) => {
  if (error_code) {
    return (
      <ChannelErrorTooltip channel={channel} status_code={error_code}>
        <AlertTriangleIcon className="text-destructive" size={16} />
      </ChannelErrorTooltip>
    );
  }

  if (isInstructionsReply) {
    return <LibraryBigIcon className="text-muted-foreground" size={16} />;
  } else if (isCollectionReply) {
    return <BookMarkedIcon className="text-muted-foreground" size={16} />;
  } else if (isCampaignReply) {
    return <GoalIcon className="text-muted-foreground" size={16} />;
  } else if (isBroadcastReply) {
    return <MegaphoneIcon className="text-muted-foreground" size={16} />;
  } else if (collection?.response_code === SynthesisResponseCode.VOICEMAIL_DETECTED) {
    return <PhoneIcon className="text-muted-foreground" size={16} />;
  } else if (collection?.response_code === SynthesisResponseCode.AUTHENTICATION_CONTINUE) {
    return <ShieldIcon className="text-muted-foreground" size={16} />;
  } else if (collection?.response_code === SynthesisResponseCode.INTERRUPTED) {
    return <HandIcon className="text-muted-foreground" size={16} />;
  }
  return <ZapIcon className="text-muted-foreground" size={16} />;
};
